import { useMutation, useQueryClient } from 'react-query';
import FeatureFlagsApi from '../FeatureFlagsApi';
import { evaluatedFeatureFlagsQueryKey } from '../../../shared/featureFlags/useEvaluatedFeatureFlagsQuery';
import { featureFlagsQueryKey } from './queryKeys';

export function useDeleteFeatureFlagMutation() {
    const queryClient = useQueryClient();

    return useMutation<void, unknown, string>(
        (key) => FeatureFlagsApi.delete(key),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([featureFlagsQueryKey]);
                queryClient.invalidateQueries([evaluatedFeatureFlagsQueryKey]);
            }
        }
    );
}
